module.exports = __webpack_public_path__ + "static/media/salao_jardim_6.87fc93d5.jpg";